<template>
  <div class="oferta-modal__overlay" @click.self="$emit('close')">
    <div class="oferta-modal" role="dialog" aria-modal="true">
      <div class="oferta-modal__header">
        <h1 class="oferta-modal__title">{{ isEdit ? 'Editar campaña' : 'Nueva campaña' }}</h1>
        <button type="button" class="oferta-modal__close" aria-label="Cerrar" @click="$emit('close')">✕</button>
      </div>

      <div class="oferta-modal__body">
        <div class="form-card">
          <div class="form-card__header">
            <h2 class="form-card__title"><i class="bi bi-tag"></i> Datos de la campaña</h2>
          </div>
          <div class="form-card__body">
            <div class="form-card__field">
              <label class="form-card__label">Nombre</label>
              <input type="text" class="form-control" v-model="name" />
            </div>

            <div class="row">
              <div class="col-12 col-sm-4">
                <div class="form-card__field">
                  <label class="form-card__label">Descuento (%)</label>
                  <input type="number" class="form-control" v-model.number="discountPercent" min="0" max="100" />
                </div>
              </div>
              <div class="col-6 col-sm-4">
                <div class="form-card__field">
                  <label class="form-card__label">Fecha desde</label>
                  <input type="date" class="form-control" v-model="startsAt" />
                </div>
              </div>
              <div class="col-6 col-sm-4">
                <div class="form-card__field">
                  <label class="form-card__label">Fecha hasta</label>
                  <input type="date" class="form-control" v-model="endsAt" :disabled="untilStockOut" />
                </div>
              </div>
            </div>

            <div class="form-check d-flex align-items-start">
              <input type="checkbox" class="form-check-input mt-1" id="until-stock-out" v-model="untilStockOut" />
              <label class="form-check-label" for="until-stock-out">
                Hasta agotar stock
                <div class="form-card__hint mt-0">Corta la oferta por producto apenas llega a 0, aunque no haya fecha de fin.</div>
              </label>
            </div>

            <div v-if="isEdit" class="form-check d-flex align-items-start mt-2">
              <input type="checkbox" class="form-check-input mt-1" id="active-toggle" v-model="active" />
              <label class="form-check-label" for="active-toggle">
                Campaña activa
                <div class="form-card__hint mt-0">Desmarcá esto para pausarla sin perder su configuración ni borrarla.</div>
              </label>
            </div>
          </div>
        </div>

        <div class="form-card">
          <div class="form-card__header">
            <h2 class="form-card__title"><i class="bi bi-bullseye"></i> Alcance</h2>
          </div>
          <div class="form-card__body">
            <div class="form-card__field">
              <label class="form-card__label">Canal</label>
              <select class="form-control" v-model="channel" style="max-width: 280px">
                <option value="both">Ambos canales</option>
                <option value="pos">Solo mostrador</option>
                <option value="online">Solo tienda online</option>
              </select>
            </div>

            <div class="form-card__field">
              <label class="form-card__label">Aplica a</label>
              <div class="btn-group mb-2">
                <button type="button" class="btn btn-outline-secondary" :class="{ active: scope === 'all' }" @click="scope = 'all'">Todo el catálogo</button>
                <button type="button" class="btn btn-outline-secondary" :class="{ active: scope === 'category' }" @click="scope = 'category'">Categoría</button>
                <button type="button" class="btn btn-outline-secondary" :class="{ active: scope === 'products' }" @click="scope = 'products'">Productos sueltos</button>
              </div>

              <div class="form-card__hint">
                <span v-if="scope === 'products'">{{ products.length }} producto(s) en oferta.</span>
                <span v-else-if="previewCount === null">Calculando productos alcanzados…</span>
                <span v-else>{{ previewCount }} producto(s) en oferta con esta configuración.</span>
              </div>

              <div v-if="scope === 'category'" class="mt-3">
                <label class="form-card__label">Categorías</label>
                <select multiple class="form-control" v-model="categoryIds" size="6">
                  <option v-for="category in categories" :key="category.id" :value="category.id" v-html="category.name"></option>
                </select>
              </div>

              <div v-if="scope === 'products'" class="mt-3">
                <label class="form-card__label">Productos</label>
                <receipt-products-search
                  :separator="'*'"
                  :show-barcodes="true"
                  :product_default="null"
                  :price-list="pricelistId"
                  @productadded="onProductAdded"
                />
                <div class="mt-2">
                  <span v-for="(product, index) in products" :key="product.id" class="badge badge-pill badge-light border mr-1 mb-1 p-2">
                    {{ product.name }}
                    <button type="button" class="btn btn-sm text-danger p-0 ml-1" @click="removeProduct(index)">✕</button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="$emit('close')">Cancelar</button>
            <button type="button" class="form-card__btn form-card__btn--primary" :disabled="!canSave" @click="save">
              <i class="bi bi-check-lg"></i> Guardar campaña
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import ReceiptProductsSearch from '../../ventas/pos-document/receipt/Receipt-products-search.vue';

export default {
  props: ['campaignId'],
  components: { ReceiptProductsSearch },
  data() {
    return {
      name: '',
      discountPercent: 0,
      startsAt: new Date().toISOString().slice(0, 10),
      endsAt: '',
      untilStockOut: false,
      channel: 'both',
      scope: 'all',
      active: true,
      categories: [],
      categoryIds: [],
      products: [],
      saving: false,
      previewCount: null,
      previewTimer: null,
    };
  },
  computed: {
    ...mapState('authUser', { authUser: (state) => state.authUser }),
    pricelistId() {
      const bo = this.authUser && this.authUser.branchoffices && this.authUser.branchoffices[0];
      return bo && bo.configs ? bo.configs.pricelist_id : null;
    },
    isEdit() {
      return !!this.campaignId;
    },
    canSave() {
      if (this.saving || this.name.trim().length === 0) return false;
      if (!(this.discountPercent > 0 && this.discountPercent <= 100)) return false;
      if (!this.untilStockOut && this.endsAt && this.endsAt < this.startsAt) return false;
      return true;
    },
  },
  watch: {
    scope() {
      this.schedulePreviewCount();
    },
    categoryIds() {
      this.schedulePreviewCount();
    },
  },
  mounted() {
    this.loadCategories();
    if (this.isEdit) {
      this.loadCampaign();
    } else {
      this.schedulePreviewCount();
    }
  },
  beforeDestroy() {
    clearTimeout(this.previewTimer);
  },
  methods: {
    loadCategories() {
      axios.get('/api/categories/getCategories').then((response) => {
        this.categories = response.data.data;
      });
    },
    // Debounce liviano: mientras se tildan varias categorías seguidas,
    // no dispara una consulta por cada click, solo la última.
    schedulePreviewCount() {
      if (this.scope === 'products') return;
      clearTimeout(this.previewTimer);
      this.previewCount = null;
      this.previewTimer = setTimeout(() => {
        axios.post('/api/offers/preview-count', {
          scope: this.scope,
          category_ids: this.categoryIds,
        }).then((response) => {
          this.previewCount = response.data.data.count;
        }).catch(() => {
          this.previewCount = null;
        });
      }, 300);
    },
    loadCampaign() {
      axios.get('/api/offers/getCampaign/' + this.campaignId).then((response) => {
        const campaign = response.data.data;
        this.name = campaign.name;
        this.discountPercent = parseFloat(campaign.discount_percent);
        this.startsAt = campaign.starts_at;
        this.endsAt = campaign.ends_at || '';
        this.untilStockOut = !!campaign.until_stock_out;
        this.channel = campaign.channel;
        this.scope = campaign.scope;
        this.active = !!campaign.active;
        this.categoryIds = (campaign.categories || []).map((c) => c.id);
        this.products = campaign.products || [];
        this.schedulePreviewCount();
      }).catch(() => {
        alert('No se pudo cargar la campaña.');
        this.$emit('close');
      });
    },
    onProductAdded(product) {
      if (this.products.find((item) => item.id === product.id)) return;
      this.products.push({ id: product.id, name: product.name });
    },
    removeProduct(index) {
      this.products.splice(index, 1);
    },
    save() {
      if (this.saving) return;
      this.saving = true;
      const payload = {
        name: this.name,
        discount_percent: this.discountPercent,
        starts_at: this.startsAt,
        ends_at: this.untilStockOut ? null : (this.endsAt || null),
        until_stock_out: this.untilStockOut,
        channel: this.channel,
        scope: this.scope,
        active: this.active,
        category_ids: this.categoryIds,
        product_ids: this.products.map((p) => p.id),
      };
      const request = this.isEdit
        ? axios.post('/api/offers/edit/' + this.campaignId, payload)
        : axios.post('/api/offers/add', payload);
      request.then(() => {
        this.$emit('saved');
      }).catch((error) => {
        this.saving = false;
        const backendMessage = error.response && error.response.data && error.response.data.message;
        const firstValidationError = error.response && error.response.data && error.response.data.errors
          ? Object.values(error.response.data.errors)[0][0]
          : null;
        alert(firstValidationError || backendMessage || 'No se pudo guardar la campaña.');
      });
    },
  },
};
</script>

<style scoped>
.oferta-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px;
  overflow-y: auto;
  background: rgba(10, 14, 20, 0.45);
}

.oferta-modal {
  width: 100%;
  max-width: 760px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.25);
}

.oferta-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 24px;
  border-bottom: 1px solid var(--border);
}

.oferta-modal__title {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.oferta-modal__close {
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  color: var(--text-muted, #6b7280);
  cursor: pointer;
}

.oferta-modal__body {
  padding: 20px 24px;
}

.oferta-modal__body .form-card {
  margin-bottom: 16px;
}

.oferta-modal__body .form-card:last-child {
  margin-bottom: 0;
}
</style>
